// web-staking-estimator-frontend/src/hooks/useUIConfig.js
import { useState, useEffect } from "react";

/**
 * Custom hook to load and manage UI configuration from backend
 * @returns {object} { uiCfg, isLoading }
 */
export function useUIConfig() {
  const [uiCfg, setUiCfg] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch("/api/config", {
          headers: { Accept: "application/json" },
        });
        const json = await response.json();
        if (!cancelled) {
          setUiCfg(json?.config || {});
        }
      } catch {
        if (!cancelled) {
          setUiCfg({});
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { uiCfg, isLoading };
}
